export default "__VITE_ASSET__sw8mpXL8__"